import type { ReactNode } from "react";

import type { CookieService } from "@/src/infrastructure/cookie-consent/CookieService";

export const youtubeCookie: CookieService = {
  iframe: {
    embedUrl: "https://www.youtube-nocookie.com/embed/{data-id}",
    iframe: {
      allow:
        "accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;",
    },
    thumbnailUrl: "https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg",
  },
  name: "Youtube",
  service: {
    label: "<strong>Youtube</strong> : visionnage de vidéos",
  },
};

interface YoutubeProps {
  readonly id: string;
}

export function YoutubeVideo({ id }: YoutubeProps): ReactNode {
  return (
    <div
      data-autoscale
      data-id={id}
      data-service={youtubeCookie.name}
      style={{
        borderRadius: "var(--radius-2xl) var(--radius-2xl) var(--radius-2xl) 0",
      }}
    />
  );
}
